import { render, staticRenderFns } from "./TicketPayment.vue?vue&type=template&id=1604e95f"
import script from "./TicketPayment.vue?vue&type=script&lang=js"
export * from "./TicketPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports